import { DOMAIN } from "../../../../../var_env."
import { setRequestEditData, setRequestEditError, setRequestEditLoading, setRequestEditMessage } from "../Reducers/EnderecoReducer"
import { RequestResponsePattern } from "../../../../../types/Request"
import { postApi } from "../../../../../utils/requestApi"
import { EnderecoType } from "../../Parametro/Types/EnderecoType"

export default async function edit(dispatch: Function, values: any){
    try {
        dispatch(setRequestEditLoading())
        
        const endpoint = `${DOMAIN}/PessoaEndereco/Update/${values.id}`
        const data = { 
            id: values.id,
            idTipoEndereco:1,
            logradouro:values.descricao.endereco,
            numero:values.descricao.numero,
            latitude:values.descricao.latitude,
            longitude:values.descricao.longitude,
            linkMapa:values.descricao.linkMapa??'',
            complemento:values.descricao.complemento,
            bairro: values.descricao.bairro,
            cep: values.descricao.cep,
            cidade: values.descricao.cidade,
            uf: values.descricao.uf,
            idIntegracao: 1,
            idUsuario: values.idUsuario
        }
        
        const response: RequestResponsePattern<EnderecoType> = await postApi({ endpoint, data })
        
        if(response){
            dispatch(setRequestEditData(response))
            if(!response.flagErro) dispatch(setRequestEditData(response))
            else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')
    } catch (error: any) {
        dispatch(setRequestEditMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestEditError())
    }
}